import Circle from '../../../../../../components/Circle'
import useResize from '../../../../../../hooks/useResize'
import UserCheckIcon from '../../../../../../icons/UserCheckIcon'
import { VIEWPORT_LG } from '../../../../../../utils/constants'
import CupIcon from '../../../../icons/CupIcon'
import { useHutritClubUploadTalentStore } from '../../../globalStore'
import RayIcon from '../../../../icons/RayIcon'
//import SelectChallenge from './InstructionsSubSteps/SelectChallenge'

const Instructions = () => {
  const { currentSubStep } = useHutritClubUploadTalentStore()
  const viewportSize = useResize()
  const isMobile = viewportSize[0] <= VIEWPORT_LG

  const renderSubSteps = {
    0: (
      <>
        <div
          className={`${
            isMobile ? 'p-3' : 'p20'
          }  d-flex flex-column align-items-start border border-2 rounded gap-3`}
          style={{
            width: isMobile ? '100%' : '890px',
            height: 'max-content',
          }}
        >
          <div className="d-flex align-items-center gap-1">
            <RayIcon />
            <span className="text-on-bg-primary text-center fontSize20">
              Reto escogido: <strong>Crea tu propio reto</strong>
            </span>
          </div>
          <div className="text-on-bg-primary fontSize14">
            <>
              <span className="fw-bolder">
                Construye una solución real para un problema real. <br />
              </span>
              <span>
                ¿Detectaste una necesidad en tu entorno o tienes una idea que
                podría ayudar a alguien? Este reto es para ti. Elige el problema
                que tú quieras resolver y crea una app funcional usando
                Lovable.dev, conectada a una base de datos como Supabase (o
                similar).
              </span>

              <div className="d-flex flex-column align-items-start text-on-bg-primary fontSize14">
                <span className="text-on-bg-primary fw-bolder mt-3 mb-3">
                  Tu objetivo:
                </span>
                <span className="text-on-bg-primary fw-bolder">
                  Crea un producto mínimo funcional (MVP) que:
                </span>
                <ul className="mt-1">
                  <li>Tenga al menos dos pantallas funcionales.</li>
                  <li>Esté conectado a una base de datos real.</li>
                  <li>
                    Resuelva un problema concreto, con un propósito claro y
                    usuarios definidos.
                  </li>
                </ul>
              </div>

              <div className="d-flex flex-column align-items-start text-on-bg-primary fontSize14">
                <span className="text-on-bg-primary fw-bolder">
                  💡 Inspírate con estos ejemplos:
                </span>
                <ul className="mt-1">
                  <li>Reservas para un coworking</li>
                  <li>Control de tareas de un equipo</li>
                  <li>Gestión de inscripciones a eventos</li>
                  <li>Biblioteca de recursos compartidos para docentes</li>
                  <li>Seguimiento de clientes o leads</li>
                  <li>Control de turnos en un negocio local</li>
                </ul>
              </div>
            </>
          </div>
        </div>
        <div className="d-flex flex-lg-row flex-column align-items-center justify-content-center gap-3 w-100 mt-4">
          <div
            className={`${
              isMobile ? 'p-3' : 'p20'
            }  d-flex flex-column align-items-start border border-2 rounded gap-3`}
            style={{
              width: isMobile ? '100%' : '434px',
              height: isMobile ? 'max-content' : '950px',
            }}
          >
            <div className="d-flex align-items-center gap-1">
              <UserCheckIcon width="24" height="24" fill="#00CF83" />
              <span className="text-on-bg-primary text-center fw-bold fontSize20">
                ¿Qué tienes que hacer?
              </span>
            </div>
            <div className="d-flex align-items-start gap-2">
              <Circle
                className="bg-on-illustration"
                classNameText="fw-bolder text-illustration"
              >
                1
              </Circle>
              <div className="d-flex flex-column align-items-start text-on-bg-primary fontSize14">
                <span className="text-on-bg-primary fw-bolder">
                  Completa un reto práctico donde se vea:
                </span>
                <ul className="mt-1 fontSize12">
                  <li>Cómo piensas.</li>
                  <li>Qué herramientas utilizas.</li>
                  <li>Qué solución propones a un problema real.</li>
                </ul>
              </div>
            </div>
            <div className="d-flex align-items-start gap-2">
              <Circle
                className="bg-on-illustration"
                classNameText="fw-bolder text-illustration"
              >
                2
              </Circle>
              <div className="d-flex flex-column align-items-start text-on-bg-primary fontSize14">
                <span className="text-on-bg-primary fw-bolder">
                  Tendrás que:
                </span>
                <ul className="mt-1 fontSize12">
                  <li>
                    Resolver un problema práctico o construir un mini-
                    <br />
                    proyecto funcional.
                  </li>
                  <li>
                    Hacer un vídeo corto (menos de 2 minutos) <br /> explicando
                    lo que has hecho y cómo.
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div
            className={`${
              isMobile ? 'p-3' : 'p20'
            }  d-flex flex-column align-items-start border border-2 rounded gap-3`}
            style={{
              width: isMobile ? '100%' : '434px',
              height: isMobile ? 'max-content' : '950px',
            }}
          >
            <div className="d-flex align-items-center gap-1">
              <CupIcon />
              <span className="text-on-bg-primary text-center fw-bold fontSize20">
                Consejos para destacar
              </span>
            </div>
            <div className="d-flex align-items-start gap-2">
              <Circle className="bg-bg-blue" width="16px" height="16px" />
              <div className="d-flex flex-column align-items-start text-on-bg-primary fontSize12">
                <span className="text-on-bg-primary fw-bolder">
                  Céntrate en resolver un problema real
                </span>
                <span className="mt-1">
                  No busques algo espectacular, busca algo útil. Piensa <br />{' '}
                  en cómo mejorar un proceso, ahorrar tiempo o <br />{' '}
                  automatizar tareas.
                </span>
              </div>
            </div>
            <div className="d-flex align-items-start gap-2">
              <Circle className="bg-bg-blue" width="16px" height="16px" />
              <div>
                <div className="d-flex flex-column align-items-start text-on-bg-primary fontSize12">
                  <span className="text-on-bg-primary fw-bolder">
                    Apóyate en herramientas de IA y no-code
                  </span>
                  <span className="mt-1">
                    Queremos ver cómo usas la tecnología a tu favor, no <br />{' '}
                    cómo haces todo a mano. Algunas ideas:
                  </span>
                  <ul>
                    <li>Usa ChatGPT para ayudarte a definir el proyecto.</li>
                    <li>
                      Utiliza Make, Bubble, Zapier, Notion, Figma, Canva, <br />{' '}
                      Framer, Webflow, etc.
                    </li>
                    <li>
                      Muestra que sabes conectar piezas, que entiendes <br /> de
                      negocio y que piensas como un solucionador.
                    </li>
                  </ul>
                </div>
                <div className="d-flex flex-column align-items-start text-on-bg-primary fontSize12">
                  <span className="text-on-bg-primary fw-bolder">
                    Ideas de uso:
                  </span>
                  <span className="text-on-bg-primary mt-3">
                    🤖 Inteligencia Artificial
                  </span>
                  <ul className="mt-1">
                    <li>
                      <a
                        className="text-on-bg-primary"
                        href="https://chatgpt.com/"
                        target="_blank"
                        rel="noreferrer"
                      >
                        {' '}
                        ChatGPT
                      </a>{' '}
                      : define y valida tu idea, genera prompts, redacta textos,
                      crea flujos de trabajo o incluso código inicial.
                    </li>
                    <li>
                      <a
                        className="text-on-bg-primary mr-1"
                        href="https://www.midjourney.com/"
                        target="_blank"
                        rel="noreferrer"
                      >
                        {' '}
                        MidJourney
                      </a>
                      o
                      <a
                        className="text-on-bg-primary"
                        href="https://stability.ai/"
                        target="_blank"
                        rel="noreferrer"
                      >
                        {' '}
                        Stable Diffusion
                      </a>
                      : crea imágenes, prototipos visuales o material de
                      marketing.
                    </li>
                    <li>
                      <a
                        className="text-on-bg-primary"
                        href="https://runwayml.com/"
                        target="_blank"
                        rel="noreferrer"
                      >
                        {' '}
                        Runway
                      </a>{' '}
                      : edita videos con IA o genera contenido multimedia.
                    </li>
                    <li>
                      <a
                        className="text-on-bg-primary"
                        href="https://www.perplexity.ai/"
                        target="_blank"
                        rel="noreferrer"
                      >
                        {' '}
                        Perplexity
                      </a>{' '}
                      : investigación rápida y fuentes confiables para validar
                      tu proyecto.
                    </li>
                  </ul>
                  <span className="text-on-bg-primary mt-2">
                    ⚡ Automatización y Workflows
                  </span>
                  <ul className="mt-1">
                    <li>
                      <a
                        className="text-on-bg-primary"
                        href="https://www.make.com/en"
                        target="_blank"
                        rel="noreferrer"
                      >
                        {' '}
                        Make
                      </a>{' '}
                      y{' '}
                      <a
                        className="text-on-bg-primary"
                        href="https://zapier.com/"
                        target="_blank"
                        rel="noreferrer"
                      >
                        {' '}
                        Zapier
                      </a>
                      : conecta apps y automatiza procesos sin código.
                    </li>
                    <li>
                      <a
                        className="text-on-bg-primary"
                        href="https://n8n.io/"
                        target="_blank"
                        rel="noreferrer"
                      >
                        {' '}
                        N8N
                      </a>
                      : alternativa open-source para automatizaciones más
                      personalizadas y avanzadas.
                    </li>
                  </ul>
                  <span className="text-on-bg-primary mt-2">
                    🛠️ Desarrollo No-Code/Low-Code
                  </span>
                  <ul className="mt-1">
                    <li>
                      <a
                        className="text-on-bg-primary"
                        href="https://bubble.io/"
                        target="_blank"
                        rel="noreferrer"
                      >
                        {' '}
                        Bubble
                      </a>
                      : plataforma potente para construir aplicaciones web
                      complejas con lógica avanzada.
                    </li>
                    <li>
                      <a
                        className="text-on-bg-primary"
                        href="https://www.webflow.com/"
                        target="_blank"
                        rel="noreferrer"
                      >
                        {' '}
                        Webflow
                      </a>
                      y{' '}
                      <a
                        className="text-on-bg-primary"
                        href="https://www.framer.com/"
                        target="_blank"
                        rel="noreferrer"
                      >
                        {' '}
                        Framer
                      </a>
                      : diseña y publica sitios web interactivos y visuales.
                    </li>
                    <li>
                      <a
                        className="text-on-bg-primary"
                        href="https://lovable.dev/"
                        target="_blank"
                        rel="noreferrer"
                      >
                        {' '}
                        Lovable
                      </a>
                      y{' '}
                      <a
                        className="text-on-bg-primary"
                        href="https://bolt.new/"
                        target="_blank"
                        rel="noreferrer"
                      >
                        {' '}
                        Bolt
                      </a>
                      : lanza productos digitales rápidamente con ayuda de IA y
                      componentes pre-hechos.
                    </li>
                  </ul>
                  <span className="text-on-bg-primary mt-2">
                    🎨 Diseño y Contenido
                  </span>
                  <ul className="mt-1">
                    <li>
                      <a
                        className="text-on-bg-primary"
                        href="https://www.figma.com/"
                        target="_blank"
                        rel="noreferrer"
                      >
                        {' '}
                        Figma
                      </a>
                      prototipado y diseño colaborativo.
                    </li>
                    <li>
                      <a
                        className="text-on-bg-primary"
                        href="https://www.canva.com/"
                        target="_blank"
                        rel="noreferrer"
                      >
                        {' '}
                        Canva
                      </a>
                      : creación rápida de materiales gráficos.
                    </li>
                    <li>
                      <a
                        className="text-on-bg-primary"
                        href="https://www.notion.so/"
                        target="_blank"
                        rel="noreferrer"
                      >
                        {' '}
                        Notion
                      </a>
                      : organiza documentación, bases de datos y gestión de{' '}
                      proyectos.
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    ),
  }

  return (
    <div className="d-flex flex-column align-items-center p-lg-0 p-2 mt-4">
      {renderSubSteps[currentSubStep]}
    </div>
  )
}

export default Instructions
